export const FRAUD_BLOCKER_SID = "eGHVNOdWdrAd56tcSnTND"
